import classNames from "classnames";
import styles from "./styles.module.scss";
import LockIcon from "@assets/icons/lock.png";
import Letter from "@assets/icons/letter.png";
import { useState } from "react";
import { Checkbox, Modal } from "antd";

interface SubscriptionAlertProps {
  onButtonClick: () => void;
}

const SubscriptionAlert: React.FC<SubscriptionAlertProps> = ({
  onButtonClick,
}) => {
  const [agree, setAgree] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <div className={styles.alertWrapper}>
        <img src={Letter} alt="letter" />
        <div className={styles.details}>
          <p>
            Subscribe to <span>Nyle.AI</span>
          </p>
          <p>
            Subscribe to the Nyle.AI newsletter to receive the latest news,
            promotions and updates
          </p>
        </div>

        <button
          onClick={() => {
            setOpenModal(true);
            // onButtonClick();
          }}
          className={classNames(styles.button, { [styles.active]: true })}
        >
          Subscribe
        </button>
      </div>

      <Modal
        width={740}
        open={openModal}
        footer={null}
        destroyOnClose
        centered
        className={styles.modal}
        onCancel={() => setOpenModal(false)}
      >
        <div className={styles.modalContent}>
          <img src={Letter} alt="letter" />

          <p className={styles.title}>Do you want to subscribe to Nyle.AI?</p>
          <div className={styles.desc}>
            By subscribing, you agree to receive emails from{" "}
            <a href="https://www.nyle.ai/ " className={styles.blue}>
              Nyle.AI
            </a>{" "}
            with the latest news, promotions, and updates. We respect your
            privacy—your email will only be used for the intended purpose, and
            you can unsubscribe anytime using the link in our emails.
            <div className={styles.privacy}>
              <img src={LockIcon} alt="lock" />
              <span>We never share your data with third parties.</span>
            </div>
          </div>

          <Checkbox
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
            className={styles.checkBox}
          >
            Yes, I want to receive emails!
          </Checkbox>

          <div className={styles.footer}>
            <button onClick={() => setOpenModal(false)}>Cancel</button>
            <button
              className={classNames(styles.subscribe, {
                [styles.active]: agree,
              })}
              disabled={!agree}
              onClick={onButtonClick}
            >
              Subscribe
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SubscriptionAlert;
